import type Eshop from '@eshop/type/eshop'
import type Rental from '@eshop/type/rental'

import css from './index.module.css'

import Image from '#/global/helper/Element/image'

type Product = Eshop.Product<'sticker'> | Rental.Product<'sticker'>

interface Props {
    product: Product
}

export const Sticker = ({ product }: Props) => {
    const list = product.sticker?.filter(x => x.isVisibleInCategory)

    return (
        <div className={`r-product-sticker ${css.wrap}`}>
            {list?.map(sticker => (
                <img
                    key={sticker.id}
                    className={css.item}
                    src={new Image(sticker.image).toWebp().getSource()}
                    alt={sticker.tooltip}
                />
            ))}
        </div>
    )
}
